import { FC, lazy, Suspense, useEffect, useState } from 'react'

import adminArb from 'assets/favicons/admin_arb.png'
import adminBlack from 'assets/favicons/admin_black.png'
import adminDemo from 'assets/favicons/admin_demo.png'
import fundArb from 'assets/favicons/fund_arb.png'
import fundBlack from 'assets/favicons/fund_black.png'
import fundDemo from 'assets/favicons/fund_demo.png'
import mpArb from 'assets/favicons/mp_arb.png'
import mpBlack from 'assets/favicons/mp_black.png'
import mpDemo from 'assets/favicons/mp_demo.png'
import { getConfig } from 'hooks/useInitConfigWallet'
import { ErrorBoundary } from 'react-error-boundary'
import TagManager from 'react-gtm-module'
import { Provider } from 'react-redux'
import { store } from 'store'

import CustomLoading from 'components/common/CustomLoading'
import Error from 'components/common/Error'
import WalletProvider from 'containers/WalletProvider'
import { setAppData } from 'store/reducers-common'
import { queryInfo } from 'store/reducers-common/Info/query'

const app = import.meta.env.VITE_APP
const { VITE_GOOGLE_TAG_MANAGER_KEY } = import.meta.env

const appImports = {
  admin: () => import('appAdmin'),
  funds: () => import('appFunds'),
  investors: () => import('appInvestors'),
}

const AppVariant = lazy(appImports[app])

const faviconMap: Record<string, string> = {
  'admin.demo.ufarm.digital': adminDemo,
  'admin.ufarm.digital': adminArb,
  'app.demo.ufarm.digital': mpDemo,
  'app.ufarm.digital': mpArb,
  'black.ufarm.digital': mpBlack,
  'eadmin.ufarm.digital': adminBlack,
  'efund.ufarm.digital': fundBlack,
  'fund.demo.ufarm.digital': fundDemo,
  'fund.ufarm.digital': fundArb,
}

const App: FC = () => {
  const [config, setConfig] = useState(null)

  useEffect(() => {
    const getInfo = async () => {
      const initInfo = store.dispatch(queryInfo.endpoints.getInfo.initiate())

      await initInfo.unwrap().then((data) => {
        store.dispatch(setAppData(data))
        getConfig(
          data.chainId,
          data.networks.map((network) => network.chainId),
        ).then((c) => setConfig(c))
      })
    }

    getInfo()
  }, [])

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: VITE_GOOGLE_TAG_MANAGER_KEY,
    }
    TagManager.initialize(tagManagerArgs)
  }, [])

  useEffect(() => {
    const { hostname } = window.location

    const favicon = document.querySelector<HTMLLinkElement>("link[rel='icon']")

    if (!favicon) return

    favicon.href = faviconMap[hostname] ?? mpArb
  }, [])

  if (!config) {
    return <CustomLoading />
  }

  return (
    <ErrorBoundary fallback={<Error />}>
      <Provider store={store}>
        <WalletProvider config={config}>
          <Suspense fallback={<CustomLoading />}>
            <AppVariant />
          </Suspense>
        </WalletProvider>
      </Provider>
    </ErrorBoundary>
  )
}
export default App
